/**
 * Confetti celebrations using canvas-confetti
 * For success moments and achievements
 */

import confetti from 'canvas-confetti';

/**
 * Default confetti burst
 */
export function celebrate() {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#34D399', '#60A5FA', '#F59E0B', '#EC4899'],
  });
}

/**
 * Success confetti (small celebration)
 */
export function successConfetti() {
  const count = 50;
  const defaults = {
    origin: { y: 0.7 },
    colors: ['#34D399', '#10B981', '#059669'],
  };

  function fire(particleRatio: number, opts: confetti.Options) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}

/**
 * Big celebration (achievement unlocked)
 */
export function bigCelebration() {
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

  function randomInRange(min: number, max: number) {
    return Math.random() * (max - min) + min;
  }

  const interval: any = setInterval(function () {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);

    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      colors: ['#34D399', '#60A5FA', '#F59E0B'],
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      colors: ['#EC4899', '#8B5CF6', '#F59E0B'],
    });
  }, 250);
}

/**
 * Fireworks effect
 */
export function fireworks() {
  const duration = 5 * 1000;
  const animationEnd = Date.now() + duration;

  (function frame() {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: ['#34D399', '#60A5FA', '#F59E0B'],
    });

    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: ['#EC4899', '#8B5CF6', '#F59E0B'],
    });

    if (Date.now() < animationEnd) {
      requestAnimationFrame(frame);
    }
  })();
}

/**
 * Star burst from position
 */
export function starBurst(x: number = 0.5, y: number = 0.5) {
  confetti({
    particleCount: 30,
    spread: 360,
    startVelocity: 20,
    origin: { x, y },
    colors: ['#FFD700', '#FFA500', '#FFFF00'],
    shapes: ['star'],
    scalar: 1.2,
  });
}

/**
 * Confetti cannon from bottom
 */
export function cannonBlast() {
  confetti({
    particleCount: 150,
    angle: 90,
    spread: 70,
    origin: { y: 1.0 },
    startVelocity: 60,
    colors: ['#34D399', '#60A5FA', '#F59E0B', '#EC4899', '#8B5CF6'],
  });
}

/**
 * School pride (two cannons)
 */
export function schoolPride() {
  const end = Date.now() + 1 * 1000;

  (function frame() {
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: ['#34D399', '#10B981'],
    });

    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: ['#60A5FA', '#3B82F6'],
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  })();
}

/**
 * Realistic confetti
 */
export function realisticConfetti() {
  const count = 200;
  const defaults = {
    origin: { y: 0.7 },
  };

  function fire(particleRatio: number, opts: confetti.Options) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio),
    });
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
}

/**
 * Quick burst for button clicks
 */
export function quickBurst(element?: HTMLElement) {
  if (element) {
    const rect = element.getBoundingClientRect();
    const x = rect.left + rect.width / 2;
    const y = rect.top + rect.height / 2;

    confetti({
      particleCount: 20,
      spread: 40,
      origin: {
        x: x / window.innerWidth,
        y: y / window.innerHeight,
      },
      colors: ['#34D399', '#60A5FA', '#F59E0B'],
      startVelocity: 20,
      scalar: 0.8,
    });
  } else {
    confetti({
      particleCount: 20,
      spread: 40,
      origin: { y: 0.6 },
      colors: ['#34D399', '#60A5FA', '#F59E0B'],
      startVelocity: 20,
      scalar: 0.8,
    });
  }
}
